import { Stack, Typography, CircularProgress,} from "@mui/material";
import React, { useEffect, useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CitySelector from "./Cityselctor";
import Button from "../../utils/Button";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import "./nm.css";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import API_ENDPOINTS from "../../config/apiEndpoints";
import TEXT_CONSTANTS from "../../config/textConstants";

const Simplify = () => {
  const navigate = useNavigate();

  // State to store the source query parameter
  const [adSource, setAdSource] = useState("");
  const [adSourceRef, setAdSourceRef] = useState("");
  const [loading, setLoading] = useState(false);

  const initialState = {
    Name: "",
    UserName: "",
    PhoneCode: "91",
    PhoneNumber: "",
    Email: "",
    CountryId: 123,
    StateId: "",
    Slug: "saniiro-7days-trial-package",
    Otp: "",
    OtpId: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [otpSent, setOtpSent] = useState(false);
  const [checkboxError, setCheckboxError] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalError, setModalError] = useState("");
  const [isChecked, setChecked] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(123);
  const [selectedState, setSelectedState] = useState("");

  useEffect(() => {
    // Get the entire query string
    const sourceRef = window.location.search; // This will include everything after the '?'

    // Optionally, you can extract the source parameter if needed
    const params = new URLSearchParams(sourceRef);
    const source = params.get("source"); // Extract the source parameter

    // Store the source in state if needed
    if (source) {
      setAdSource(source);
      setAdSourceRef(sourceRef);
    }

    // You can also log or use the sourceRef variable as needed
    //console.log("Source Reference:", sourceRef);
  }, []); // Empty dependency array to run only once on mount

  // Validation rules for the form fields
  const validationRules = {
    Name: (value) => value.length > 2 || TEXT_CONSTANTS.VALIDATION.NAME_REQUIRED,
    Email: (value) => /^\S+@\S+\.\S+$/.test(value) || TEXT_CONSTANTS.VALIDATION.EMAIL_INVALID,
    UserName: (value) => value.length > 0 || TEXT_CONSTANTS.VALIDATION.USERNAME_REQUIRED,
    PhoneNumber: (value) => (selectedCountry === 123 ? value.length > 0 : true) || TEXT_CONSTANTS.VALIDATION.PHONE_NUMBER_REQUIRED,
    CountryId: (value) => value > 0 || TEXT_CONSTANTS.VALIDATION.COUNTRY_REQUIRED,
    StateId: (value) => value > 0 || TEXT_CONSTANTS.VALIDATION.STATE_REQUIRED,
  };

  // Validate the form data
  const validateForm = () => {
    const tempErrors = Object.keys(validationRules).reduce((acc, key) => {
      const error = validationRules[key](formData[key]);
      if (error !== true) acc[key] = error; // Add error message if validation fails
      return acc;
    }, {});

    setErrors(tempErrors); // Update errors state
    return Object.keys(tempErrors).length === 0; // Return true if no errors
  };
 

  // Handle input changes in the form
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Prevent updating phone number if it exceeds 10 characters
    if (name === "PhoneNumber" && value.length > 10) {
      return;
    }

    // Update form data state
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear errors for the field being changed
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }

    // Clear checkbox error if other fields are updated
    if (name !== "checkbox" && checkboxError) {
      setCheckboxError("");
    }
  };

  // Handle checkbox state change
  const handleCheckboxChange = () => {
    setChecked(!isChecked);
    setCheckboxError(!isChecked ? "" : "You must agree to the Terms of Service and Privacy Policy");
  };
 
  // Fetch countries from the API
  useEffect(() => {
    const fetchCountries = async () => {
      const response = await axios.get(API_ENDPOINTS.GET_COUNTRIES);
      setCountries(response.data.Data || []); // Update countries state
    };
    fetchCountries();
  }, []);

  // Fetch states based on the selected country
  useEffect(() => {
    const fetchStates = async () => {
      if (!selectedCountry) return; // Exit if no country is selected
      const response = await axios.get(API_ENDPOINTS.GET_STATES, {
        params: { CountryId: selectedCountry },
      });
      setStates(response.data.Data || []); // Update states state
    };
    fetchStates();
  }, [selectedCountry]);

  // Handle country selection change
  const handleCountryChange = (e) => {
    const newCountryId = Number(e.target.value);
    setSelectedCountry(newCountryId);
    setSelectedState(""); // Reset state when country changes
    setFormData((prev) => ({
      ...prev,
      CountryId: newCountryId,
      StateId: "",
      PhoneNumber: newCountryId === 123 ? prev.PhoneNumber : "",
    }));
  };

  // Handle state selection change
  const handleStateChange = (e) => {
    const newState = e.target.value;
    setSelectedState(newState);
    const foundState = states.find((state) => state.Name === newState);
    setFormData((prev) => ({
      ...prev,
      StateId: foundState ? Number(foundState.Id) : 0,
    }));
  };
  
  // Send OTP to the user
  const sendOTP = async () => {
    if (!validateForm()) return; // Validate form before sending OTP
    setLoading(true);

    try {
      const response = await axios.get(API_ENDPOINTS.SEND_OTP, {
        params: {
          Action: "OTP",
          ApiForId: selectedCountry === 123 ? 2 : 1,
          MobileTo: selectedCountry === 123 ? formData.PhoneNumber : null,
          EmailTo: formData.Email,
          GroupId: 41,
        },
      });
      if (response.data.Status === 1000) {
        setFormData((prev) => ({ ...prev, OtpId: response.data.Data[0].Id }));
        setOtpSent(true); // Mark OTP as sent
        alert(TEXT_CONSTANTS.MESSAGES.OTP_SENT_SUCCESS); // Example of using text constant
      } else {
        setModalError(TEXT_CONSTANTS.MESSAGES.OTP_VERIFICATION_FAILED);
        setModalVisible(true);
      }
    } catch (error) {
      console.error(TEXT_CONSTANTS.ERRORS.CONSOLE.API_CALL_FAILED, error);
      setModalError(TEXT_CONSTANTS.ERRORS.MODAL.GENERIC_ERROR);
      setModalVisible(true);
    } finally {
      setLoading(false);
    }
  };

  // Verify the OTP entered by the user
  const verifyOTP = async () => {
    if (!formData.Otp) {
      setModalError(TEXT_CONSTANTS.ERRORS.MODAL.OTP_REQUIRED);
      setModalVisible(true);
      return;
    }
    setLoading(true);

    try {
      // console.log(formData);
      const response = await axios.post(API_ENDPOINTS.VERIFY_OTP_AND_PURCHASE, {
        ...formData,
        CountryId: Number(formData.CountryId),
        StateId: Number(formData.StateId),
        PhoneNumber: selectedCountry === 123 ? formData.PhoneNumber : null,
        AdSource: adSource,
        AdSourceRef: adSourceRef,
      });
      if (response.data.Status === 1000) {
        const transactionId = response.data.Data.Txnid;
        localStorage.setItem("validTxnId", transactionId); // Set flag in local storage as Store transaction ID
        navigate(`/thank-you/${transactionId}`); // Navigate to thank you page
      } else {
        setModalError("Failed to verify OTP");
        setModalVisible(true);
      }
    } catch (error) {
      console.error(TEXT_CONSTANTS.ERRORS.CONSOLE.API_CALL_FAILED, error);
      setModalError(TEXT_CONSTANTS.ERRORS.MODAL.GENERIC_ERROR);
      setModalVisible(true);
    } finally {
      setLoading(false);
    }
  };

  // Reset the form to its initial state
  const resetForm = () => {
    setOtpSent(false);
    setErrors({});
    setAdSource("");
    setAdSourceRef("");
    setFormData((prev) => ({
      ...prev,
      Otp: "", // Reset OTP field to empty
      AdSource: "", // Reset add source field to empty
      AdSourceRef: "", // Reset add source params field to empty
    }));
  };
  

  return (
    <>
      <Stack height={{ xl: "1000px", sm: "" }} pt={10}>
        <Stack
          alignItems={"center"}
          justifyContent={"space-between"}
          p={"0 10px"}
          // direction={"row"}
          // zIndex={-1}
          sx={{
            flexDirection: {
              xs: "column",
              lg: "row",
            },
            // width: "100%",
            margin: {
              xs: "0px",
              sm: "20px",
              lg: "0px",
            },
          }}
        >
          <Stack
            alignItems={{ lg: "flex-start", sm: "center" }}
            sx={{
              width: {
                xs: "100%",
                lg: "56%",
                xl: "42%",
                xxl: "50%",
              },
              margin: {
                lg: "30px",
                xl: "30px",
              },
              padding: {
                xs: "10px 0",
              },
            }}
          >
            <Typography
              textTransform={"uppercase"}
              sx={{
                fontSize: {
                  xs: "55px",
                  sm: "55px",
                  lg: "85px",
                  xl: "108px",
                },
                textAlign: {
                  xs: "center",
                  lg: "left",
                },
              }}
              color={"#052973"}
              // color={"white"}
              fontWeight={900}
              lineHeight={1}
              letterSpacing={"0.05em"}
            >
              Simplify Your
            </Typography>
            <Typography
              className="text-stroke"
              fontFamily={"monospace"}
              sx={{
                textTransform: "uppercase",
                fontSize: {
                  xs: "55px",
                  sm: "55px",
                  lg: "85px",
                  xl: "108px",
                },
                textAlign: {
                  xs: "center",
                  lg: "left",
                },
                fontWeight: "bold",
                letterSpacing: 1,
                color: "transparent",
                lineHeight: 1,
              }}
            >
              Business
            </Typography>
            <Typography
              // color={"white"}
              color={"black"}
              sx={{
                width: {
                  xs: "90%",
                  sm: "80%",
                  lg: "90%",
                },
                margin: {
                  xs: "20px auto 0px",
                  lg: "20px 0px 0px",
                },

                fontSize: {
                  xs: "14px",
                  lg: "18px",
                },
                textAlign: {
                  xs: "center",
                  lg: "left",
                },
              }}
            >
              Saniiro Technologies propels business efficiency to new heights
              with our tailored SaaS platform. Elevate customer engagement and
              smart operations to transform your enterprise.
            </Typography>
            <Stack direction={"row"} gap={2} pt={4}>
              <Link to={"/Contact-us"} onClick={() => window.scrollTo(0, 0)}>
                <Button
                  sx={{
                    fontSize: {
                      xs: "10px",
                      sm: "12px",
                      md: "18px",
                    },
                    bgcolor: "white",
                    color: "black",
                    border: "1px solid black",

                    fontWeight: "bold",
                    p: 1.5,
                    "&:hover": {
                      backgroundColor: "#052973",
                      color: "white",
                    },
                  }}
                >
                  Explore Demo Account
                </Button>
              </Link>
            </Stack>
          </Stack>

          <Stack
            bgcolor={"#052973"}
            borderRadius={4}
            gap={3}
            sx={{
              width: {
                xs: "85%",
                sm: "90%",
                md: "69%",
                lg: "50%",
                xl: "43%",
              },
              margin: {
                xs: "20px 0px",
                lg: "20px",
                xl: "39px 11px",
              },
              padding: {
                xs: "20px 0px",
                sm: "20px",
                lg: "20px 0px",
                xl: "30px 0px",
              },
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "18px",
                  sm: "22px",
                  md: "28px",
                  xl: "28px",
                },
                textAlign: {
                  xs: "center",
                },
              }}
              color={"white"}
              // color={"white"}
              fontWeight={"bold"}
              textAlign={"center"}
            >
              Begin Your Journey with{" "}
              <span style={{ color: "rgb(241, 91, 37)" }}>Saniiro</span> Today!
            </Typography>
            <Stack
              alignItems={"center"}
              gap={2}
              margin={"0 auto"}
              sx={{
                width: {
                  xs: "80%",
                  sm: "100%",
                  md: "70%",
                  lg: "100%",
                  xl: "100%",
                },
              }}
            >
              <Stack>
                <Stack
                  style={{ position: "relative" }}
                  sx={{
                    width: {
                      xs: "220px",
                      sm: "268px",
                      smm: "400px",
                      md: "480px",
                      lg: "385px",
                      xl: "480px",
                    },
                    height: {
                      xs: "45px",
                      sm: "47px",
                      md: "67px",
                      lg: "57px",
                      xl: "67px",
                    },
                  }}
                >
                  <input
                    style={{
                      width: "94%",
                      height: "100%",
                      border: "1px solid #AAAAAA",
                      color: otpSent ? "#DDDDDD" : "#AAAAAA",
                      paddingLeft: "5%",
                      fontSize: "20px",
                      borderRadius: "12px",
                    }}
                    type="text"
                    name="Name"
                    disabled={otpSent}
                    placeholder="Full Name"
                    value={formData.Name}
                    onChange={handleInputChange}
                  />

                  <PersonIcon
                    sx={{
                      position: "absolute",
                      top: "50%",
                      right: "8px",
                      transform: "translateY(-50%)",
                      color: "#AAAAAA",
                      fontSize: {
                        xl: "40px",
                        md: "35px",
                        lg: "38px",
                        sm: "30px",
                      },
                    }}
                  />
                </Stack>
                {errors.Name && (
                  <Typography color="error">{errors.Name}</Typography>
                )}
              </Stack>
              <Stack>
                <Stack
                  style={{ position: "relative" }}
                  sx={{
                    width: {
                      xs: "220px",
                      sm: "268px",
                      smm: "400px",
                      md: "480px",
                      lg: "385px",
                      xl: "480px",
                    },
                    height: {
                      xs: "45px",
                      sm: "47px",
                      md: "67px",
                      lg: "57px",
                      xl: "67px",
                    },
                  }}
                >
                  <input
                    type="email"
                    name="Email"
                    placeholder="Work Email"
                    value={formData.Email}
                    onChange={handleInputChange}
                    disabled={otpSent}
                    style={{
                      width: "94%",
                      height: "100%",
                      border: "1px solid #AAAAAA",
                      color: otpSent ? "#DDDDDD" : "#AAAAAA",
                      paddingLeft: "5%",
                      fontSize: "20px",
                      borderRadius: "12px",
                    }}
                  />

                  <EmailIcon
                    sx={{
                      position: "absolute",
                      top: "50%",
                      right: "8px",
                      transform: "translateY(-50%)",
                      color: "#AAAAAA",
                      fontSize: {
                        xl: "40px",
                        md: "35px",
                        lg: "38px",
                        sm: "30px",
                      },
                    }}
                  />
                </Stack>
                {errors.Email && (
                  <Typography color="error">{errors.Email}</Typography>
                )}
              </Stack>
              <Stack>
                <Stack
                  style={{ position: "relative" }}
                  sx={{
                    width: {
                      xs: "220px",
                      md: "480px",
                      sm: "268px",
                      smm: "400px",
                      lg: "385px",
                      xl: "480px",
                    },
                    height: {
                      xs: "45px",
                      sm: "47px",
                      md: "67px",
                      lg: "57px",
                      xl: "67px",
                    },
                  }}
                >
                  <input
                    type="text"
                    name="UserName"
                    placeholder="User name"
                    value={formData.UserName}
                    onChange={handleInputChange}
                    disabled={otpSent}
                    style={{
                      width: "94%",
                      height: "100%",
                      border: "1px solid #AAAAAA",
                      paddingLeft: "5%",
                      color: otpSent ? "#DDDDDD" : "#AAAAAA",
                      fontSize: "20px",
                      borderRadius: "12px",
                    }}
                  />

                  <AccountCircleIcon
                    sx={{
                      position: "absolute",
                      top: "50%",
                      right: "8px",
                      transform: "translateY(-50%)",
                      color: "#AAAAAA",
                      fontSize: {
                        xl: "40px",
                        md: "35px",
                        lg: "38px",
                        sm: "30px",
                      },
                    }}
                  />
                </Stack>
                {errors.UserName && (
                  <Typography color="error">{errors.UserName}</Typography>
                )}
              </Stack>
              <CitySelector
                selectedCountry={selectedCountry}
                handleCountryChange={handleCountryChange}
                countries={countries}
                selectedState={selectedState}
                handleStateChange={handleStateChange}
                states={states}
                errors={errors}
                otpSent={otpSent}
              />

              <Stack>
                {selectedCountry === 123 && (
                  <Stack
                    style={{ position: "relative" }}
                    sx={{
                      width: {
                        xs: "220px",
                        sm: "268px",
                        smm: "400px",
                        md: "480px",
                        lg: "385px",
                        xl: "480px",
                      },
                      height: {
                        xs: "45px",
                        sm: "47px",
                        md: "67px",
                        lg: "57px",
                        xl: "67px",
                      },
                    }}
                  >
                    <input
                      type="tel"
                      className="input-new"
                      value={formData.PhoneNumber}
                      name="PhoneNumber"
                      placeholder="Phone Number"
                      onChange={handleInputChange}
                      maxLength={16}
                      disabled={otpSent}
                      style={{
                        width: "94%",
                        height: "100%",
                        border: "1px solid #AAAAAA",
                        color: otpSent ? "#DDDDDD" : "#AAAAAA",
                        paddingLeft: "5%",
                        fontSize: "20px",
                        borderRadius: "12px",
                        WebkitAppearance: "none", // for Chrome, Safari, Edge, Opera
                        MozAppearance: "textfield",
                      }}
                    />

                    <PhoneAndroidIcon
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: "16px",
                        transform: "translateY(-50%)",
                        color: "#AAAAAA",
                        fontSize: {
                          xl: "40px",
                          md: "35px",
                          lg: "38px",
                          sm: "30px",
                        },
                      }}
                    />
                  </Stack>
                )}
                {formData.PhoneNumber.length === 16 && (
                  <div style={{ color: "red" }}>
                    Maximum 16 characters allowed.
                  </div>
                )}
                {errors.PhoneNumber && (
                  <Typography color="error">{errors.PhoneNumber}</Typography>
                )}
              </Stack>
              {/* <PhoneNumberInput formData={formData} setFormData={setFormData} errors={errors} /> */}
              <Stack
                gap={2}
                sx={{
                  alignItems: {
                    xs: "center",
                    lg: "left",
                  },
                }}
              >
                <Stack>
                  <Stack
                    direction={"row"}
                    gap={1}
                    sx={{ textAlign: { xs: "left", lg: "left" } }}
                  >
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <Typography fontSize={"13px"} color={"white"}>
                      {TEXT_CONSTANTS.CHECKBOX.I_AGREE}
                    </Typography>
                  </Stack>
                  {checkboxError && (
                    <Typography
                      color="error"
                      sx={{ fontSize: "14px", marginLeft: "20px" }}
                    >
                      {checkboxError}
                    </Typography>
                  )}
                </Stack>
                <Stack gap={"20px"} alignItems={"center"}>
                  {otpSent ? (
                    <>
                      <Stack
                        sx={{
                          width: {
                            xs: "220px",
                            sm: "268px",
                            smm: "400px",
                            md: "480px",
                            lg: "385px",
                            xl: "480px",
                          },
                          height: {
                            xs: "45px",
                            sm: "47px",
                            md: "67px",
                            lg: "57px",
                            xl: "67px",
                          },
                        }}
                      >
                        <input
                          type="number"
                          className="input-new"
                          value={formData.Otp}
                          name="Otp"
                          placeholder="OTP"
                          onChange={handleInputChange}
                          maxLength={16}
                          style={{
                            width: "94%",
                            height: "100%",
                            border: "1px solid #AAAAAA",
                            color: "#AAAAAA",
                            paddingLeft: "5%",
                            fontSize: "20px",
                            borderRadius: "12px",
                            WebkitAppearance: "none", // for Chrome, Safari, Edge, Opera
                            MozAppearance: "textfield",
                          }}
                        />
                      </Stack>
                      <Stack alignItems={"flex-end"} width={"95%"}>
                        <Typography
                          onClick={resetForm}
                          color={"white"}
                          sx={{ cursor: "pointer" }}
                        >
                          Edit Details
                        </Typography>
                      </Stack>
                      <Button
                        type="button"
                        sx={{
                          borderRadius: "10px",
                          width: {
                            xs: "220px",
                            sm: "268px",
                            smm: "400px",
                            md: "480px",
                            lg: "385px",
                            xl: "400px",
                          },
                          height: {
                            xs: "45px",
                            sm: "55px",
                            md: "67px",
                            lg: "57px",
                            xl: "67px",
                          },
                          color: "white",
                          fontSize: {
                            xs: "16px",
                            sm: "19px",
                            md: "22px",
                          },
                          bgcolor: "#F15B25",
                          fontWeight: "bold",
                          "&:hover": {
                            backgroundColor: "#F15B25",
                            border: "1px solid #052973",
                            color: "white",
                          },
                        }}
                        onClick={verifyOTP}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={24} color="inherit" /> : TEXT_CONSTANTS.BUTTON.VERIFY_OTP}
                      </Button>
                    </>
                  ) : (
                    <Button
                      type="button"
                      sx={{
                        borderRadius: "10px",
                        width: {
                          xs: "220px",
                          sm: "268px",
                          smm: "400px",
                          md: "480px",
                          lg: "385px",
                          xl: "400px",
                        },
                        height: {
                          xs: "45px",
                          sm: "55px",
                          md: "67px",
                          lg: "57px",
                          xl: "67px",
                        },
                        color: "white",
                        fontSize: {
                          xs: "16px",
                          sm: "19px",
                          md: "22px",
                        },
                        bgcolor: "#F15B25",
                        fontWeight: "bold",
                        "&:hover": {
                          backgroundColor: "#F15B25",
                          border: "1px solid #052973",
                          color: "white",
                        },
                      }}
                      onClick={sendOTP}
                      disabled={loading}
                    >
                      {loading ? <CircularProgress size={24} color="inherit" /> : TEXT_CONSTANTS.BUTTON.TRY_IT_FREE}
                    </Button>
                  )}
                </Stack>
                {modalVisible && (
                  <div className="modalBackground">
                    <Stack>
                      <div className="modalContainer">
                        <div className="titleCloseBtn">
                          <button onClick={() => setModalVisible(false)}>
                            X
                          </button>
                        </div>
                        <Stack
                          p={{ lg: "20px 40px 40px 40px", xs: "10px 20px" }}
                        >
                          <>
                            {modalMessage && (
                              <Typography fontSize={"30px"} color="green">
                                {modalMessage}
                              </Typography>
                            )}
                            {modalError && (
                              <Typography fontSize={"15px"} color="red">
                                {modalError}
                              </Typography>
                            )}
                          </>
                        </Stack>
                      </div>
                    </Stack>
                  </div>
                )}
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default Simplify;
